import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class SpecialOrdersService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getSpecialOrders(partnerId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/api/Orders?PartnerID=' + partnerId, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getSpecialOrdersV2(partnerId: string, refresh: boolean = false) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/SpecialOrders/${partnerId}?code=${this.env.key}&refresh=${refresh}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getItemsOutOfStock(partnerId: string) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/ItemsOutOfStock/${partnerId}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
